import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import dates from 'react-big-calendar/lib/utils/dates'
import BigCalendar from 'react-big-calendar'
import * as instructorActions from '../../_actions/roster.actions'
import { mergeWithDefaults } from 'react-big-calendar/lib/localizer'
import Toolbar from './Toolbar'
import _ from 'lodash'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import { navigate } from './constants'

import ReportContents from './ReportContents'
import { reports } from './constants'
import { viewConstants } from '../../_constants/view.constants'

const moment = require('moment')
const _localizer = BigCalendar.momentLocalizer(moment)

const localizer = mergeWithDefaults(_localizer, 'en-NZ', {}, {})

class WeeklyReport extends Component {
    static defaultProps = {
        getNow: () => new Date(),
    }
    state = {
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEvents: [],
        displayEmployees: [],
        show: false,
        activeTab: '1',
        selectedBranch: {},
        selectedDepartment: {},
        mounted: false,
        current: [],
        currentDate: new Date(),
    }

    componentDidMount = () => {
        const defaultRange = this.range(this.props.getNow())
        this.setState({ current: defaultRange })

        const options = {
            range: viewConstants.WEEK,
            time: new Date(),
        }

        this.props.actions.fetchUpdateWorkETime(options)
    }

    range = date => {
        let firstOfWeek = localizer.startOfWeek()
        let start = dates.startOf(date, 'week', firstOfWeek)
        let end = dates.endOf(date, 'week', firstOfWeek)

        return dates.range(start, end)
    }

    handleRangeChange = date => {
        const range = this.range(date)
        this.setState({ current: range, currentDate: date })
        const options = {
            range: viewConstants.WEEK,
            time: date,
        }

        this.props.actions.fetchUpdateWorkETime(options)
    }

    handleBranchChange = branch => {
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch.value !== 'all') {
            filterCond.branch = branch.value
        }
        if (selectedDepartment.value && selectedDepartment.value !== 'all') {
            filterCond.department = selectedDepartment.value
        }
        filterCond.view = reports.WEEKLY
        this.props.actions.updateWeeklyReportDisplayEvents(filterCond)
        this.setState({
            selectedBranch: branch,
        })
    }

    handleDepartmentChange = department => {
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department.value !== 'all') {
            filterCond.department = department.value
        }
        if (selectedBranch.value && selectedBranch.value !== 'all') {
            filterCond.branch = selectedBranch.value
        }
        filterCond.view = reports.WEEKLY

        this.props.actions.updateWeeklyReportDisplayEvents(filterCond)
        this.setState({
            selectedDepartment: department,
        })
    }

    handleNavigate = (action, newDate) => {
        // const currentDate = this.state.currentDate;

        switch (action) {
            case navigate.PREVIOUS:
                // const previousWeek = dates.subtract(currentDate, 7, "day");
                this.handleRangeChange(newDate)
                break
            case navigate.NEXT:
                // const nextWeek = dates.add(currentDate, 7, "day");
                this.handleRangeChange(newDate)
                break
            case navigate.TODAY:
                this.handleRangeChange(new Date())
                break
            case navigate.DATE:
                this.handleRangeChange(newDate)
                break
            default:
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    {/* <div className="col-sm-3">
            <div className="reportToolBar">
              <BrancheSelect handleChange={this.handleBranchChange.bind(this)} />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="reportToolBar">
              <DepartmentSelect
                handleChange={this.handleDepartmentChange.bind(this)}
              />
            </div>
          </div> */}
                    <div className="col-sm-6">
                        <Toolbar onNavigate={this.handleNavigate} />
                    </div>
                    <div>
                        <ReportContents
                            localizer={localizer}
                            range={this.state.current}
                            getNow={this.props.getNow}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        employees: state.roster.employeeList,
        selectedEmployee: state.roster.selectedEmployee,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(WeeklyReport)
